module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }